(function($, window, undefined) {

  var defaults = {
    selectorPrefix: 'wbsk-cart'
  };

  function wbskCart(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings);
    this.removeCtrl = `.${this.settings.selectorPrefix}__remove-from-cart`;
    this.qtySelector = `.${this.settings.selectorPrefix}__item-qty-selctor`;
    this.qtyCtrl = `.${this.settings.selectorPrefix}__item-qty`;
    this.wrapper = `.${this.settings.selectorPrefix}__wrapper`;
    this.cartTemplate = $(`.${this.settings.selectorPrefix}__cart-template`);
    this.count = $(`.${this.settings.selectorPrefix}__cart-count`);
    this.count_items = $(`.${this.settings.selectorPrefix}__cart-count-items`);
    this.actions = `.${this.settings.selectorPrefix}__actions`;
    this.empty = `.${this.settings.selectorPrefix}__empty`;
   
    this.bind();
    this.update('init');
  };
  
  wbskCart.prototype = {
    
    arraySum:function(array){
       return array.reduce((a, b) => a + b, 0)
    },
    bind: function() {
      var _this = this;
      //remove item
      $(document).on('click', this.removeCtrl, function(e) {
        e.preventDefault()
        _this.removeItem($(this))
      })
      //qty change event
      $(document).on('change', this.qtyCtrl, function(e) {
        e.preventDefault()
        _this.updateQty($(this))
      }.debounce(100))
      
    },
    
    postToCart:function(data,url){
      var _this = this;
      url = url || '/cart/add.js'
      return new Promise(function(resolve,reject){
        $.ajax({
          type: 'POST',
          url:url,
          data:data, 
          dataType: 'json',
          success: function(cart) {
            resolve(cart)
          },
          error:function(err) {
            reject(err)
          }
        });  
      })
    },

    addToCart:function(form,data){
      var _this = this;
      return new Promise(function(resolve,reject){
        data = data ? data : $(form).serialize() 
        _this.postToCart(data).then(function(cart){
          _this.update('add').then(function(){
            if(_this.settings.onAdded && typeof _this.settings.onAdded == 'function'){
               _this.settings.onAdded(cart)
            }
            resolve(cart)
          })
        }).catch(function(err){
          reject(err)
        })
      })
    },
    
    addArrayToCart:function(data){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      return new Promise(function(resolve,reject){
        const item = data.shift()
        _this.postToCart(item).then( cart => {
          if(data.length){
            _this.addArrayToCart(data)
          }else{
            _this.update('add').then(function(){
              if(_this.settings.onAdded && typeof _this.settings.onAdded == 'function'){
                 _this.settings.onAdded(cart)
              }
              resolve(cart)
            })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    
    update:function(type){
      var _this = this,
          url = _this.settings.cartFetchUrl;
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        _this.fetchHandler(url).then(function(result){
          return result.text();
        }).then(function(html){
          _this.cartTemplate.html(html)
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
            _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
          }
          _this.getCartJSON().then(function(cart){
            // save the cart json
            _this.cart_data = cart
            // get a list of all variant qtys in the cart
            let cart_variant_qtys = cart.items.map( item => {
              return {
                variant_id:item.variant_id,
                quantity:item.quantity
              }
            })
            
            _this.cart_variant_qtys = {}
            cart_variant_qtys.forEach( item => {
              _this.cart_variant_qtys[item.variant_id] = _this.cart_variant_qtys[item.variant_id] || 0
              _this.cart_variant_qtys[item.variant_id] = _this.cart_variant_qtys[item.variant_id] + item.quantity
            })
            const count = cart.item_count
            //update the cart counter
	       _this.count.text(count)
           _this.count_items.text(`${count} ${count == 1 ? 'Item' : 'Items'}`)
    
            //fire the update event
            var event = new CustomEvent('update_cart' , {bubbles: true});
            event.updateType = type
            event.cart = cart
            _this.element[0].dispatchEvent(event);
            
            PubSub.publish('onWbskCartUpdate',cart)
            resolve()
          })
        })
      })
    },
    
    updateQty:function($item){
      var _this = this,
          url = $item.attr('data-update') + $item.val();
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.fetchHandler(url).then(function(res){
        _this.update()
      })
    },
    
    removeItem:function($item){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
      }
      _this.fetchHandler($item.attr('href')).then(function(res){
        _this.update('remove')
      })
      
    },
    
    fetchHandler:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          resolve(result)
        }).catch(function(error){
          reject(error)
        })
      })
    },
    
    getCartJSON:function(){
      var _this = this
      return new Promise(function(resolve,reject){
        fetch('/cart.js').then(function(result){
          return result.json()
        }).then(function(data){
          resolve(data)
        });
      })
    },
    
    removeItemsByProperty:function(key,value){
      var _this = this
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        const items = _this.cart_data.items.filter( item => item.properties && item.properties[key] && item.properties[key] == value)
        const data = { updates: {} };
 
        for (const item of items) {
          data.updates[item.key] = 0;
        }

        _this.postToCart(data,'/cart/update.js').then( cart => {
          _this.update()
        })
       
       
      })
    },
    
    
    removeItemsByKey:function(key){
      var _this = this
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        const items = _this.cart_data.items.filter( item => item.key == key)
        const data = { updates: {} };
 
        for (const item of items) {
          data.updates[item.key] = 0;
        }

        _this.postToCart(data,'/cart/update.js').then( cart => {
          _this.update()
        })
       
       
      })
    }
    
  };

  $.fn.wbskCart = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskCart', new wbskCart(this, settings))
    })
  }

}(jQuery, window));




